"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// libs
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var format_date_1 = __importDefault(require("./format-date"));
var translations_1 = require("../translations");
var propTypes = {
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number,
        prop_types_1.default.instanceOf(Date)
    ]),
    TextComponent: prop_types_1.default.any
};
var FormattedDate = /** @class */ (function (_super) {
    __extends(FormattedDate, _super);
    function FormattedDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onLanguageChange = function () { return _this.forceUpdate(); };
        return _this;
    }
    FormattedDate.prototype.componentDidMount = function () {
        translations_1.languageChangeEvent.on(this.onLanguageChange);
    };
    FormattedDate.prototype.componentWillUnmount = function () {
        translations_1.languageChangeEvent.off(this.onLanguageChange);
    };
    FormattedDate.prototype.render = function () {
        var _a = this.props, value = _a.value, _b = _a.TextComponent, TextComponent = _b === void 0 ? 'span' : _b, props = __rest(_a, ["value", "TextComponent"]);
        var locale = translations_1.CURRENT_LOCALE_CODE;
        return react_1.default.createElement(TextComponent, __assign({}, props), value && format_date_1.default(locale, value));
    };
    return FormattedDate;
}(react_1.Component));
// @ts-ignore
FormattedDate.propTypes = propTypes;
exports.default = FormattedDate;
//# sourceMappingURL=formatted-date.js.map